import CourseStatusLabel from "./CourseStatusLabel";
import React from "react";
import { CustomLink } from "./CustomLink";
import { FeedbackGiscus } from "./FeedbackGiscus";
import { Heading, Stack, Text, chakra } from "@chakra-ui/react";

export const FeedbackLesson: React.FC<{
  isCourseBeta: boolean;
  courseTitle: string;
}> = ({ isCourseBeta, courseTitle }) => {
  return (
    <>
      <Stack spacing={4}>
        <Heading as={chakra.h2} size="md">
          Share your questions and comments about this lesson
        </Heading>
        <Text>
          {isCourseBeta && (
            <span>
              This course is currently in
              <CourseStatusLabel status="beta" /> .{" "}
            </span>
          )}
          Your feedback helps us improve! If you&apos;re stuck or confused, let
          us know and we&apos;ll help you out. All comments are public and must
          follow the{" "}
          <CustomLink
            href="https://www.apollographql.com/docs/community/code-of-conduct/"
            color={"link"}
          >
            Apollo Code of Conduct
          </CustomLink>
          . Note that comments that have been resolved or addressed may be
          removed.
        </Text>
        <Text>
          You&apos;ll need a GitHub account to post below. Don&apos;t have one?{" "}
          <CustomLink
            href="https://community.apollographql.com/tags/c/other/22/odyssey"
            color={"link"}
            onClick={() =>
              window.gtag?.("event", "forums_lesson_feedback_click", {
                courseTitle,
              })
            }
          >
            Post in our Odyssey forum instead.
          </CustomLink>
        </Text>
        <FeedbackGiscus />
      </Stack>
    </>
  );
};
